export default() => document.documentElement.scrollTop = 0
